import { render, staticRenderFns } from "./cangchuKc.vue?vue&type=template&id=5d1e316e&scoped=true&"
import script from "./cangchuKc.vue?vue&type=script&lang=js&"
export * from "./cangchuKc.vue?vue&type=script&lang=js&"
import style0 from "./cangchuKc.vue?vue&type=style&index=0&id=5d1e316e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1e316e",
  null
  
)

export default component.exports